/**
 * Reveal
 * ======
 * Scroll-triggered fade/rise used for staggered section entrances.
 * Renders inert (no animation, no layout shift) under reduced motion.
 */

import { motion } from 'framer-motion';
import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion';

const Reveal = ({
  children,
  delay = 0,
  y = 28,
  duration = 0.9,
  once = true,
  className = '',
  as = 'div',
  ...props
}) => {
  const reduced = usePrefersReducedMotion();

  if (reduced) {
    const Static = as;
    return <Static className={className}>{children}</Static>;
  }

  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '-80px' }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
      {...props}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
